import React, {useEffect, useState} from 'react'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import useCustomFetch from '../../../../hooks/useFetchContent'
import {Box, useBreakpointValue} from '@salesforce/retail-react-app/app/components/shared/ui'
import {containerStyles, topCategoriesStyle, noSliderContainerStyles} from './index.style'
import {CustomNextArrow, CustomPrevArrow} from '../../../../components/custom-arrows'
import LoadingSpinner from '@salesforce/retail-react-app/app/components/loading-spinner'
import Slider from 'react-slick'
import PropTypes from 'prop-types'
import BrandHeader from './brand-header'

const CategoryHeader = ({category, selectedRefinements}) => {
    const {token} = useAccessToken()
    const [slides, setSlides] = useState([])
    const [currentSlide, setCurrentSlide] = useState(0)
    const {response, loading} = useCustomFetch(
        token,
        `category-header-carousel:category:${category?.id}`,
        true
    )
    const isMobile = useBreakpointValue({base: true, md: false})

    useEffect(() => {
        if (response) {
            const parser = new DOMParser()
            const slideElements = parser
                .parseFromString(response, 'text/html')
                .querySelectorAll('.category-banner-tile')
            setSlides(Array.from(slideElements, (slide) => slide.outerHTML))
        }
    }, [response])

    const settings = {
        infinite: slides.length > 3,
        speed: 500,
        slidesToShow: slides.length > 3 ? 3.1 : slides.length,
        slidesToScroll: 1,
        autoplay: false,
        beforeChange: (_, newIndex) => setCurrentSlide(newIndex),
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow visibility={currentSlide === 0 ? 'hidden' : 'visible'} />,
        responsive: [
            {
                breakpoint: 1023,
                settings: {centerPadding: '30px'}
            },
            {
                breakpoint: 767,
                settings: {
                    infinite: false,
                    arrows: true,
                    slidesToShow: slides.length > 1 ? 1.5 : slides.length,
                    beforeChange: (_, newIndex) => setCurrentSlide(newIndex),
                    nextArrow: <CustomNextArrow />,
                    prevArrow: (
                        <CustomPrevArrow visibility={currentSlide === 0 ? 'hidden' : 'visible'} />
                    )
                }
            }
        ]
    }

    return (
        <Box sx={containerStyles}>
            {loading ? (
                <LoadingSpinner />
            ) : (
                <>
                    <BrandHeader category={category} selectedRefinements={selectedRefinements} />
                    {slides.length > 0 && (
                        <Box sx={topCategoriesStyle}>
                            {slides.length > (isMobile ? 1 : 3) ? (
                                <Slider {...settings}>
                                    {slides.map((slideHtml, index) => (
                                        <Box
                                            className="slide-item"
                                            key={index}
                                            dangerouslySetInnerHTML={{__html: slideHtml}}
                                        />
                                    ))}
                                </Slider>
                            ) : (
                                <Box sx={noSliderContainerStyles}>
                                    {slides.map((slideHtml, index) => (
                                        <Box
                                            className="slide-item"
                                            key={index}
                                            dangerouslySetInnerHTML={{__html: slideHtml}}
                                        />
                                    ))}
                                </Box>
                            )}
                        </Box>
                    )}
                </>
            )}
        </Box>
    )
}

CategoryHeader.propTypes = {
    category: PropTypes.object,
    selectedRefinements: PropTypes.object
}

export default CategoryHeader
